<template>
  <div class="auth-layout">
    <Nuxt />
  </div>
</template>

<script>
import connectionCheck from '@mixins/connection-check'

export default {
  name: 'Auth',
  mixins: [connectionCheck]
}
</script>
